import {type InputHTMLAttributes} from 'react';
import classNames from 'classnames';
import {useCurrentThemeVariant} from '#/features/store/themeColorsStore';

type Props = InputHTMLAttributes<HTMLInputElement> & {type: 'radio'};

function RadioInput(props: Props) {
  const variant = useCurrentThemeVariant();
  const className = props.className ?? '';

  return (
    <input
      {...props}
      className={classNames(className, variant === 'light' ? '[color-scheme:only_light]' : '[color-scheme:only_dark]')}
    />
  );
}

export default RadioInput;
